module.exports = __webpack_public_path__ + "img/logomark-blue@2x.99f1e97c.png";